import { FC, useMemo } from 'react';

import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import Video from 'yet-another-react-lightbox/plugins/video';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';

import { getOrCreateBlobUrl } from '@/shared/lib/hooks/useResourceImage';

interface Props {
  open: boolean;
  onClose: () => void;
  images: File[];
  startingIndex?: number;
}

const ImagesLightbox: FC<Props> = ({ open, onClose, images, startingIndex }) => {
  const slides = useMemo(
    () =>
      images.map((image) => {
        const url = getOrCreateBlobUrl(image);
        if (image.name.includes('.mp4')) {
          return {
            type: 'video',
            sources: [{ src: url, type: 'video/mp4' }],
          };
        }
        return { type: 'image', src: url };
      }),
    [images],
  );

  return (
    <Lightbox
      open={open}
      index={startingIndex || 0}
      close={onClose}
      // @ts-ignore
      slides={slides}
      plugins={[Thumbnails, Zoom, Video, Fullscreen]}
    />
  );
};

export default ImagesLightbox;
